module.exports = __webpack_public_path__ + "static/media/eokhati_full_green.b1430ef3.png";